import { SvgIcon } from '@mui/material';

function DropletIcon() {
  return (
    <SvgIcon
      role="img"
      viewBox="0 0 10 14"
      sx={{ fontSize: '0.875rem' }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <svg
        width="10"
        height="14"
        viewBox="0 0 10 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.62001 0C4.62001 0 0 5.15791 0 9.39484C0 11.938 2.06831 14 4.62001 14C7.17149 14 9.24002 11.938 9.24002 9.39484C9.24002 5.25003 4.62001 0 4.62001 0ZM4.75042 12.6998C4.69789 12.7154 4.62366 12.748 4.52397 12.7708C4.42364 12.7934 4.29581 12.8213 4.15154 12.8321C4.0786 12.8413 4.00126 12.8442 3.91843 12.8437C3.8354 12.8452 3.74838 12.8416 3.65686 12.832C3.47306 12.8181 3.2753 12.7748 3.06872 12.7101C2.86526 12.6393 2.65019 12.5482 2.44964 12.4167C2.34587 12.3556 2.24972 12.2804 2.15338 12.2036C2.10633 12.1637 2.05917 12.1234 2.01158 12.0832C1.96657 12.0401 1.9236 11.995 1.87935 11.9504C1.70521 11.7708 1.55311 11.5678 1.42086 11.3569C1.29486 11.1425 1.18453 10.9223 1.10054 10.6983C1.0594 10.5866 1.01923 10.4753 0.990329 10.3634C0.956922 10.2524 0.930602 10.1422 0.908258 10.0328C0.865182 9.81464 0.835963 9.6028 0.824468 9.40213C0.81104 9.20157 0.813511 9.01207 0.822105 8.83849C0.833492 8.66457 0.85186 8.50623 0.874742 8.36681C0.899127 8.22737 0.924586 8.10706 0.951764 8.00801C0.975505 7.9094 1.00526 7.83217 1.02105 7.78028C1.03856 7.72786 1.05006 7.70004 1.05006 7.70004C1.05006 7.70004 1.06241 7.72678 1.08551 7.7777C1.10645 7.82765 1.13728 7.90102 1.17649 7.99459C1.25083 8.18021 1.35062 8.4419 1.46461 8.74514C1.52187 8.89414 1.58385 9.05581 1.64948 9.2264C1.71244 9.39516 1.78666 9.56745 1.85885 9.74373C1.93394 9.91904 2.01633 10.094 2.09905 10.269C2.18789 10.4405 2.27608 10.6118 2.37663 10.7729C2.47278 10.9365 2.58267 11.0868 2.69244 11.2318C2.80373 11.3762 2.9249 11.5055 3.04832 11.6274C3.17154 11.7504 3.30463 11.8551 3.43643 11.9547C3.50389 12.002 3.56974 12.0505 3.63785 12.0912C3.67179 12.1129 3.70509 12.1345 3.73764 12.1556C3.77169 12.1745 3.80564 12.1921 3.83851 12.2119C3.90361 12.2529 3.97021 12.2837 4.03391 12.3166C4.09697 12.3522 4.15938 12.3789 4.21879 12.4067C4.33792 12.4653 4.44308 12.5057 4.53363 12.547C4.62774 12.5852 4.70164 12.6152 4.75213 12.6357C4.80294 12.6582 4.83001 12.6701 4.83001 12.6701C4.83001 12.6701 4.8023 12.6804 4.75041 12.6998L4.75042 12.6998Z"
          fill="url(#paint0_linear_2980_7996)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2980_7996"
            x1="0"
            y1="0"
            x2="9.60292"
            y2="0.253518"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.9999" stopColor="#54D6FF" />
            <stop offset="1" stopColor="#2525FF" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export default DropletIcon;
